export const SET_INFOMODULO = 'SET_INFOMODULO';


const initialState = {
    infoM: [],
}

export function infoModuloReducer(state = initialState, action) {
    var newState = state

    switch (action.type) {
        case SET_INFOMODULO:
            newState = { ...newState, infoM: action.infoModulos };
            break
            default: return state
    }
    
    return newState;
}
